import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfsls, fetchAssetClassOrder } from './thunks';
import { ReportSettingsState, Afsl, AssetClassOrderItem } from './types';

export const initialState: ReportSettingsState = {
  afsls: [],
  afslId: undefined,
  assetClassOrderItems: [],
};

export const reportSettingsSlice = createSlice({
  name: '@@client/securities/assetclassorderitems/Fetch',
  initialState,
  reducers: {
    setAfslId: (state, action: PayloadAction<number | undefined>) => {
      state.afslId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAssetClassOrder.fulfilled, (state: ReportSettingsState, action: PayloadAction<AssetClassOrderItem[]>) => {
      state.assetClassOrderItems = action.payload;
    });
    builder.addCase(fetchAfsls.fulfilled, (state, action: PayloadAction<Afsl[]>) => {
      state.afsls = action.payload.sort((a, b) => a.name.localeCompare(b.name));
      if (!state.afslId && state.afsls.length > 0) {
        state.afslId = state.afsls[0].id;
      }
    });
  },
});
